import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'reactstrap';
import { CheckBoxField } from '@/shared/components/form/CheckBox';

const ALWAYS_VISIBLE_IDS = ['expander', 'name'];

const ColumnVisibilityDropdown = ({ allColumns }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const toggleableColumns = allColumns.filter(
    (column) => !column.columns && !ALWAYS_VISIBLE_IDS.includes(column.id)
  );

  return (
    <div ref={containerRef} style={{ position: 'relative', display: 'inline-block' }} className="mr-2">
      <Button
        className="btn btn-sm btn-secondary"
        color="#ffffff"
        onClick={() => setIsOpen((open) => !open)}
      >
        Columns
      </Button>
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 10,
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            padding: '8px 12px',
            minWidth: 220,
            maxHeight: 320,
            overflowY: 'auto',
            textAlign: 'left'
          }}
        >
          {toggleableColumns.map((column) => {
            const { checked, onChange } = column.getToggleHiddenProps();
            return (
              <div key={column.id} style={{ padding: '4px 0' }}>
                <CheckBoxField
                  name={column.id}
                  label={typeof column.Header === 'string' ? column.Header : column.id}
                  checked={checked}
                  onChange={onChange}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ColumnVisibilityDropdown;
